var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("path",{"className":"social-icon__fill","d":"m10.12 3.66666667h-2.31c-1.21 0-1.54.77777777-1.54 1.55555555v1.55555556h3.85l-.44 3.22222222h-3.41v9.5555556h-3.85v-9.5555556h-1.54v-3.22222222h1.54v-1.55555556c0-2.66666666 1.54-4.77777778 4.62-4.77777778h3.08z","fill":"#12141c","fillRule":"evenodd","key":1})]);
}

FacebookIcon.defaultProps = {"className":"social-icon social-icon--facebook facebook-icon","height":"20","viewBox":"0 0 11 20","width":"11"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
